import * as _ from 'lodash';

export const getLoadingList = (state) => {
	return _.get(state, 'shippingPartner.listShippingPartner.loading', false);
};

export const getShippingPartnersSuggest = (state) => {
	return _.get(state, 'shippingPartner.listShippingPartner.listSuggest', []);
};
